import React from 'react'
import Block from '../../Block';
import { Loader } from '../../components';
import OriginalShowItem from '../../ShowItem';
import { useTranslation } from 'react-i18next';
import { Col, Row } from 'react-bootstrap';
import { formatDate } from '../../Format';
import get from 'lodash/get';
import DailyData from './general/DailyData';

const ShowItem = (props) => {
  const labelSize = {
    sm: 6,
    md: 6,
    lg: 6,
    xl: 6,
  }

  return <OriginalShowItem {...labelSize} {...props} />
}

const GlobalInfos = (props) => {
  const loaderProps = { success: props.isSuccess, error: props.isError, retry: props.retry }
  const { t } = useTranslation();
  const {app} = props;

  return ( <>
  <Row>
    <Block title={t('app.general.general')} as={Col} md={12} lg={6} fullHeight >
      <Loader {...loaderProps} minHeight={"100%"}>
        <ShowItem label={t('app.enabled')} value={app.enabled} bool/>
        <ShowItem label={t('app.environment')} value={app.environment}/>
        <ShowItem label={t('app.created_at')} value={formatDate(app.created_at)}/>
        <ShowItem label={t('app.production_date')} value={formatDate(app.production_date)}/>
      </Loader>
    </Block>
    <Block title={t('app.general.cmp_approval')} as={Col} md={12} lg={6} fullHeight >
      <Loader {...loaderProps} minHeight={"100%"}>
        <ShowItem label={t('app.is_cmp')} value={app.is_cmp} bool/>
        <ShowItem label={t('app.cmp_approved')} value={app.cmp_approved} bool/>
        <ShowItem label={t('app.cmp_approved_at')} value={formatDate(app.cmp_approved_at)}/>
        <ShowItem label={t('app.cmp_approved_by')} value={app.cmp_approved_by?.full_name}/>
      </Loader>
    </Block>
  </Row>
  <Row>
    <Block title={t('app.general.sdk_version')} as={Col} md={12} lg={6} fullHeight >
      <Loader {...loaderProps} minHeight={"100%"}>
        <ShowItem label={t('app.test_sdk_version')} value={get(app, 'test_sdk.version')}/>
        <ShowItem label={t('app.test_sdk_date')} value={formatDate(get(app, 'test_sdk.date'))}/>
        <ShowItem label={t('app.prod_sdk_version')} value={get(app, 'prod_sdk.version')}/>
        <ShowItem label={t('app.prod_sdk_date')} value={formatDate(get(app, 'prod_sdk.date'))}/>
      </Loader>
    </Block>
    <Block title={t('app.general.app_version')} as={Col} md={12} lg={6} fullHeight >
      <Loader {...loaderProps} minHeight={"100%"}>
        <ShowItem label={t('app.test_app_version')} value={get(app, 'test_app.version')}/>
        <ShowItem label={t('app.test_app_date')} value={formatDate(get(app, 'test_app.date'))}/>
        <ShowItem label={t('app.prod_app_version')} value={get(app, 'prod_app.version')}/>
        <ShowItem label={t('app.prod_app_date')} value={formatDate(get(app, 'prod_app.date'))}/>
      </Loader>
    </Block>
  </Row>
  </> );
}

const General = (props) => {
  return ( <>
  <GlobalInfos {...props}/>
  {
    props.isSuccess &&
    <DailyData appId={props.app.id}/>
  }
  </> );
}

export default General;
